import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import axios from "axios";
export default new Vuex.Store({
  state: function () {
    return {
      siteConfig: [],
      homeUrl: "",
      retrievalSelection: null,
      queryParams: "",
      DateFormatted_: "",
      ssnInput_: "",
      zipInput_: ""
    };
  },

  mutations: {
    setConfig(state, payload) {
      state.siteConfig = payload;
    },
    setHome(state, payload) {
      state.homeUrl = payload;
    },
    setSelection(state, payload) {
      state.retrievalSelection = payload;
    },
    setQueryParams(state, payload) {
      state.queryParams = payload;
    },
  },
  actions: {
    retrievalSelection(state, payload) {
      state.commit("setSelection", payload.choice);
    },
    setConfig(state, payload) {
      axios.get("./configs/configs.json").then(function (response) {
        var filter = response.data.map(function (n) {
          return n.site;
        });
        state.commit(
          "setConfig",
          filter.includes(payload.site)
            ? response.data.filter(function (n) {
              return n.site == payload.site;
            })[0]
            : response.data.filter(function (n) {
              return n.site == "";
            })[0]
        );
      });
    },
    setHome(state) {
      state.commit(
        "setHome",
        location.protocol +
        "//" +
        location.hostname +
        "/web_projects/MainHomePage/Login.aspx"
      );
    },
    setParams(state, payload) {
      state.commit("setQueryParams", payload.params);
    },
  },
  modules: {},
  getters: {
    getConfig(state) {
      return state.siteConfig;
    },
    getHome(state) {
      return state.homeUrl + state.queryParams;
    },
    getParams(state) {
      return state.queryParams;
    },
  },
});
